import { render, staticRenderFns } from "./FeedbackInfo.vue?vue&type=template&id=774d26ba&scoped=true&"
import script from "./FeedbackInfo.vue?vue&type=script&lang=js&"
export * from "./FeedbackInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackInfo.vue?vue&type=style&index=0&id=774d26ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d26ba",
  null
  
)

export default component.exports